import { createFileRoute } from "@tanstack/react-router";
import Careers from "@/pages/Careers";
import { careersHead } from "@/lib/route-seo";

export const Route = createFileRoute("/about/careers")({
  head: () => careersHead(),
  component: Careers,
});
